import Types from '../Types';
import Immutable from 'seamless-immutable';
import { createReducer } from 'reduxsauce';
import { get } from 'lodash';

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false, giveaways: [], pageCount: 0,
  findOneAttempting: false,
  addAttempting: false,
  saveAttempting: false
});

const ACTION_HANDLERS = {
  [Types.FIND_ALL_GIVEAWAYS_ATTEMPT] : (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_ALL_GIVEAWAYS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      giveaways: get(action, 'result.giveaways') || [],
      pageCount: get(action, 'result.pageCount') || 0,
      error: null
    }),
  [Types.FIND_ALL_GIVEAWAYS_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error })
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);


/** WEBPACK FOOTER **
 ** ./src/redux/giveaway/giveawayReducer.js
 **/